// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { AnnouncementRepresentation } from "../../types";
import type { UseApiFetchOptions, UseApiFetchResponse } from "../../composables/useApiFetch";
import type { NitroFetchOptions } from "nitropack";
import type { Ref, MaybeRef } from "vue";
import {
    $apiFetch,
    computed,
    unref,
    useApiFetch,
    useFetchDependencies
} from "#imports";

export function useAnnouncementResource () {

    /**
     * Get any announcements for the URL being visited
     * @param url (optional) The URL being visited
     * @return Any announcements to take place
     */
    function getForUrl(
        url?: MaybeRef<string | undefined>
    ) : UseApiFetchResponse<AnnouncementRepresentation[]> {
        const computedUrl = computed( () => {
          let url_ = "/api/announcements/url?";

        const urlUnref = unref( url );
        if (urlUnref === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (urlUnref !== undefined)
            url_ += "url=" + encodeURIComponent("" + urlUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<AnnouncementRepresentation[]> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<AnnouncementRepresentation[]>( computedUrl, options_ );
    }

    return {
        getForUrl,
    }
}


export function $announcementResource () {

    const dependencies_ = useFetchDependencies();

    /**
     * Get any announcements for the URL being visited
     * @param url (optional) The URL being visited
     * @return Any announcements to take place
     */
    function getForUrl(
        url?: string | undefined
    ) {
        let url_ = "/api/announcements/url?";

        const urlUnref = unref( url );
        if (urlUnref === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (urlUnref !== undefined)
            url_ += "url=" + encodeURIComponent("" + urlUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<AnnouncementRepresentation[]>( url_, options_, dependencies_ );
    }

    return {
        getForUrl,
    }
}